export function createAbortControl<T = void>() {
    const ac = new AbortController();
    return [ac.signal, abort.bind(ac)] as [
        AbortSignal & {reason: ReplaceVoid<T, DOMException> | undefined},
        (reason: T) => void,
    ];
}

type Replace<T, Domain, Codomain> = T extends Domain ? Codomain : T;
type ReplaceVoid<T, Codomain> = Replace<T, void, Codomain>;

/** separate function for debug purposes */
function abort<T = any>(this: AbortController, reason?: T) {
    if (reason === undefined) {
        this.abort();
    } else {
        this.abort(reason);
    }
}
